document.addEventListener('DOMContentLoaded', function() {
  
    
     // Get all top-level menu list items
      document.querySelectorAll('.list-menu--inline li').forEach(li => {
        li.addEventListener('mouseenter', () => {
          const details = li.querySelector('.mega-menu');
          if (details) {
            details.setAttribute('open', '');
          }
        });
    
        li.addEventListener('mouseleave', () => {
          const details = li.querySelector('.mega-menu');
          if (details) {
            details.removeAttribute('open');
          }
        });
      });

      

     const menuIcon = document.querySelector('.menu-icon');
      const catgoryMenu = document.querySelector('.header-search-category');
      const menuSection = document.querySelector('.seven-menu-section');
      const openCategorySection = document.querySelector('.open-category');
    
      if (menuIcon && menuSection) {
        // Show menu on icon hover
        menuIcon.addEventListener('mouseenter', function() {
          menuSection.classList.add('activated');
        });

        if (openCategorySection ) {
          openCategorySection.addEventListener('mouseenter', function() {
            menuSection.classList.add('activated');
          });
        }
    
        // Hide menu when mouse leaves menu section
        menuSection.addEventListener('mouseleave', function() {
          menuSection.classList.remove('activated');
        });
    
        // Also show on icon click (optional)
        menuIcon.addEventListener('click', function(e) {
          e.stopPropagation();
          menuSection.classList.add('activated');
        });

        catgoryMenu.addEventListener('click', function(e) {
          e.stopPropagation();
          menuSection.classList.add('activated');
        });

        
    
        // Optional: close if user clicks outside the menu or icon
        document.addEventListener('click', function(e) {
          if (!menuSection.contains(e.target) && !menuIcon.contains(e.target)) {
            menuSection.classList.remove('activated');
          }
        });
      }

    document.querySelector('.search__button-mobile').addEventListener('click', function() {
      const searchList = document.querySelector('body');
      const details = document.querySelector('details');
    
      searchList.classList.toggle('search__activated');
    
      // Open the details if not already open
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });


    document.querySelector('.modal__close-button.link').addEventListener('click', function() {
      const searchListClose = document.querySelector('body');
      const details = document.querySelector('details');
    
      // Remove class
      searchListClose.classList.remove('search__activated');
    
      // ✅ Properly close the <details>
      details.removeAttribute('open');
    });
   
    new Swiper('.top-product-swiper', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Navigation arrows
      navigation: {
        nextEl: '.top-nav-group .swiper-button-next',
        prevEl: '.top-nav-group .swiper-button-prev',
      },
      
    });

     new Swiper('.top-product-thumbnail', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Navigation arrows
      navigation: {
        nextEl: '.top-nav-group .swiper-button-next',
        prevEl: '.top-nav-group .swiper-button-prev',
      },
      
    });

    

    new Swiper('.product-media-swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true
    });

    
    new Swiper('.product-swiper', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      // Pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });

    
    new Swiper('#best-selling-products', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      autoplay: {
        delay: 39999000, // Delay between slides in ms
        disableOnInteraction: false // Keeps autoplay running after interaction
      },
      
      // Pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });

    new Swiper('.canadian-product-swiper', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.canadian-proudcts .swiper-button-next',
        prevEl: '.canadian-proudcts .swiper-button-prev',
      },
      
    });


     const productSlider = document.querySelector(".product-sliders");

if (productSlider) {
  var swiper = new Swiper(".product-sliders", {
    cssMode: true,
    loop: true,
    navigation: {
      nextEl: ".product-sliders .swiper-button-next",
      prevEl: ".product-sliders .swiper-button-prev",
    },
    pagination: {
      el: ".product-sliders .swiper-pagination",
      clickable: true,
    },
  });
}

    const isDesktop = () => window.innerWidth > 1;

	let gap = 15;

	if (isDesktop()) gap = 0.0285 * window.innerWidth;

	const sliders = [];

	["#horizontal-ticker-rtl", "#horizontal-ticker-ltr"].forEach(
		(query, index) => {
			sliders.push(
				new Swiper(query, {
					loop: true,
					slidesPerView: "auto",
					spaceBetween: gap,
					speed: 15000,
					allowTouchMove: false,
					autoplay: {
						delay: 0,
						reverseDirection: index,
						disableOnInteraction: false
					}
				})
			);
		}
	);

	window.addEventListener("resize", () => {
		isDesktop() ? (gap = 0.0285 * window.innerWidth) : (gap = 15);

		sliders.forEach((slider) => {
			slider.params.spaceBetween = gap;
			slider.update();
		});
	});

// MOBILE: move media gallery just under the title
if (window.innerWidth <= 749) {
  const title = document.querySelector('.product__title');
  const mediaGallery = document.querySelector('media-gallery');

  if (title && mediaGallery) {
    title.parentNode.insertBefore(mediaGallery, title.nextSibling);
  }
}

  });

